export const version = '__VERSION__'
export const sha = '__SHA__'
